// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

function Form$Label(Props) {
  var textOpt = Props.text;
  var text = textOpt !== undefined ? textOpt : "";
  return React.createElement("div", {
              className: "text-size-label"
            }, text);
}

var Label = {
  make: Form$Label
};

function Form$InputText(Props) {
  var value = Props.value;
  var onChange = Props.onChange;
  var placeholderOpt = Props.placeholder;
  var errorOpt = Props.error;
  var inputMode = Props.inputMode;
  var pattern = Props.pattern;
  var placeholder = placeholderOpt !== undefined ? placeholderOpt : "";
  var error = errorOpt !== undefined ? Caml_option.valFromOption(errorOpt) : undefined;
  var cls = error !== undefined ? ({
        color: "red",
        rounded: "rounded-t-3xl rounded-b-2xl"
      }) : ({
        color: "black",
        rounded: "rounded-3xl"
      });
  var tmp = {
    className: "px-3 py-2 bg-transaprent rounded-3xl w-full focus:outline-none",
    placeholder: placeholder
  };
  if (inputMode !== undefined) {
    tmp.inputMode = Caml_option.valFromOption(inputMode);
  }
  if (pattern !== undefined) {
    tmp.pattern = Caml_option.valFromOption(pattern);
  }
  if (value !== undefined) {
    tmp.value = Caml_option.valFromOption(value);
  }
  if (onChange !== undefined) {
    tmp.onChange = Caml_option.valFromOption(onChange);
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "\n        flex flex-col w-full " + cls.rounded + "\n        bg-" + cls.color + "\n      "
                }, React.createElement("div", {
                      className: "bg-white rounded-3xl border-" + cls.color + " border-2"
                    }, React.createElement("input", tmp)), error !== undefined ? React.createElement("div", {
                        className: "text-white px-3 pb-1 text-xs py-1"
                      }, error) : null));
}

var InputText = {
  make: Form$InputText
};

function Form$GroupInput(Props) {
  var children = Props.children;
  var classNameOpt = Props.className;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  return React.createElement("div", {
              className: "\n        flex flex-col\n        w-full\n        py-2\n        space-y-1\n        " + className + "\n      "
            }, children);
}

var GroupInput = {
  make: Form$GroupInput
};

function Form$Radio(Props) {
  var checkedOpt = Props.checked;
  var label = Props.label;
  var onClick = Props.onClick;
  var checked = checkedOpt !== undefined ? checkedOpt : false;
  var tmp = {};
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  return React.createElement("div", tmp, React.createElement("input", {
                  className: "text-white ring-2 ring-black border-none",
                  checked: checked,
                  type: "radio",
                  onChange: (function (param) {
                      
                    })
                }), React.createElement("span", {
                  className: "px-2"
                }, label));
}

var Radio = {
  make: Form$Radio
};

function Form$Checkbox(Props) {
  var checkedOpt = Props.checked;
  var onChangeOpt = Props.onChange;
  var checked = checkedOpt !== undefined ? checkedOpt : false;
  var onChange = onChangeOpt !== undefined ? onChangeOpt : (function (param) {
        
      });
  return React.createElement(React.Fragment, undefined, React.createElement("input", {
                  className: "p-1 text-red border-2 border-red rounded-sm",
                  checked: checked,
                  type: "checkbox",
                  onChange: onChange
                }));
}

var Checkbox = {
  make: Form$Checkbox
};

var key_placeholder = "___PLACEHOLDER";

function newOptionT(x) {
  return {
          value: x,
          label: x
        };
}

function Form$Select$Option(Props) {
  var value = Props.value;
  var label = Props.label;
  return React.createElement("option", {
              value: value
            }, label);
}

var $$Option = {
  newOptionT: newOptionT,
  make: Form$Select$Option
};

function dataOptionFromArray(arr) {
  return arr.map(newOptionT);
}

function Form$Select(Props) {
  var data = Props.data;
  var value = Props.value;
  var onChangeOpt = Props.onChange;
  var disabledOpt = Props.disabled;
  var onChange = onChangeOpt !== undefined ? onChangeOpt : (function (param) {
        
      });
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var items = Belt_Array.map(data, (function (x) {
          return React.createElement(Form$Select$Option, {
                      value: x.value,
                      label: x.label,
                      key: x.value
                    });
        }));
  var handleOnChange = function (x) {
    return Curry._1(onChange, x.target.value);
  };
  var cls_placeholder = value === "___PLACEHOLDER" ? "text-gray-500" : "";
  return React.createElement("select", {
              className: "w-full rounded-3xl px-3 py-2 border-2 border-black " + cls_placeholder,
              disabled: disabled,
              value: value,
              onChange: handleOnChange
            }, items);
}

var Select = {
  $$Option: $$Option,
  dataOptionFromArray: dataOptionFromArray,
  make: Form$Select
};

function Form$SelectWithInitialPlaceholder(Props) {
  var placeholder = Props.placeholder;
  var data = Props.data;
  var value = Props.value;
  var onChangeOpt = Props.onChange;
  var onChange = onChangeOpt !== undefined ? onChangeOpt : (function (param) {
        
      });
  var data$1;
  if (value !== undefined) {
    data$1 = data;
  } else {
    var h = {
      value: key_placeholder,
      label: placeholder
    };
    data$1 = Belt_Array.concat([h], data);
  }
  return React.createElement(React.Fragment, undefined, React.createElement(Form$Select, {
                  data: data$1,
                  value: Belt_Option.getWithDefault(value, key_placeholder),
                  onChange: onChange
                }));
}

var SelectWithInitialPlaceholder = {
  make: Form$SelectWithInitialPlaceholder
};

function Form$LabelLock(Props) {
  var label = Props.label;
  return React.createElement("div", {
              className: "w-full rounded-3xl px-3 py-2 bg-light-gray flex justify-between"
            }, React.createElement("div", {
                  className: "pl-1"
                }, label), React.createElement("img", {
                  src: "./icons/locked-padlock.svg"
                }));
}

var LabelLock = {
  make: Form$LabelLock
};

function Form$TextArea(Props) {
  var placeholder = Props.placeholder;
  var value = Props.value;
  var onChange = Props.onChange;
  var rows = Props.rows;
  var tmp = {
    className: "w-full rounded-xl border-2 border-black"
  };
  if (placeholder !== undefined) {
    tmp.placeholder = Caml_option.valFromOption(placeholder);
  }
  if (rows !== undefined) {
    tmp.rows = Caml_option.valFromOption(rows);
  }
  if (value !== undefined) {
    tmp.value = Caml_option.valFromOption(value);
  }
  if (onChange !== undefined) {
    tmp.onChange = Caml_option.valFromOption(onChange);
  }
  return React.createElement("textarea", tmp);
}

var TextArea = {
  make: Form$TextArea
};

export {
  Label ,
  InputText ,
  GroupInput ,
  Radio ,
  Checkbox ,
  key_placeholder ,
  Select ,
  SelectWithInitialPlaceholder ,
  LabelLock ,
  TextArea ,
  
}
/* react Not a pure module */
